// @ts-nocheck
import local from '../../assets/local.svg'
import calendar from '../../assets/calendar.svg'
import star from '../../assets/star.svg'
import {
  useParams,
  useNavigate,
  useSearchParams,
  useMatches,
} from 'react-router-dom'
import { useContext, useEffect, useState, useMemo } from 'react'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import ManagerGoalsCard from '../ManagerGoalsCard'
import CalendarDashboard from '../Calendar'
import Loader from '../Loader'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useAuth, useGuard } from '../../hooks/auth'
import DateContext from '../../hooks/date'
import LoaderContext from '../../hooks/loading'
import { dateFormat } from '../../utils/dateFormat'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import ConditionalRenderComponent from '../RenderControl'
import {
  FContainer,
  CalendarContiner,
  Container,
  DateManager,
  DetailsContainer,
  DetailsTitleContainer,
  GoalsManagerCardContainer,
  HeaderContainer,
  HeaderTitleText,
  HeatMapContainer,
  Img,
  MainContainer,
  PageVisitsCardContainer,
  SalesByProductContainer,
  SalesCardContainer,
  SelectDateContainer,
  SelectDateContainerMobile,
  SelectDateText,
  SelectDateTextMobile,
  TitleContainer,
  TotalCardContainer,
  SectionContainer,
  HeaderDetailText,
  DisableScroll,
  CenterElement,
} from './styles'
import {
  DashboardCard,
  DashboardPageVistitsCard,
  DashboardSalesChart,
  DashboardSalesByProductCard,
  Icon,
  DashboardVisitorsCard,
  DashboardVisitorsChart,
  DashboardPageSalesByHourCard,
} from 'bd-web-components'
import SalesMap from '../SalesMap'
import {
  mockDashboardData,
  mockEvent,
  mockHeatMapCoords,
  mockInterestMeter,
  mockSalesByDay,
  mockSalesByHour,
  mockSalesByProduct,
  mockSalesLocator,
  mockSectors,
  mockVisitors,
  mockVisitorsInformation,
  mockPaymentMethods,
  mockBuyerRecurrence,
  mockSalesCurve,
  mockCampaignAttribution,
} from '../../utils/dashMockData'
import IndicatorCard from '../DashboardCharts/IndicatorCard'
import GeoSalesCard from '../DashboardCharts/GeoSalesCard'
import AgeGenderChart from '../DashboardCharts/AgeGenderChart'
import PaymentBars from '../DashboardCharts/PaymentBars'
import RecurrenceGauges from '../DashboardCharts/RecurrenceGauges'
import SalesCurveCard from '../DashboardCharts/SalesCurveCard'
import SalesCurveConfigModal from '../DashboardCharts/SalesCurveConfigModal'
import SalesOrigin from '../DashboardCharts/SalesOrigin'
import { CardsRow, GearButton, ToggleLabel } from '../DashboardCharts/styles'
import { DashboardDataProps, RequestArrayProps } from '../types/main-component'
import { hasSuccessItem } from '../../utils/verifyRequestArray'
import SectionHeader from '../SectionHeader'
// @ts-ignore
import { animateScroll } from 'react-scroll'
import PageVisitsContainer from '../PageVisitorContainer'
import PageSalesByHourContainer from '../PageSalesByHourContainer'
import InterestMeterContainer from '../InterestMeterContainer'
import { toast } from 'react-toastify'
import { LoadingSpinner } from '../ManagerGoalsCard/styles'
import { Breadcrumb } from '../Breadcrumb'
import { useIsWebView } from '../../hooks/is-webview'
import useBdApp from '../../hooks/bdapp/useBdApp'

const makeInViewOnceRef = (setInView: (v: boolean) => void) => {
  let observer: IntersectionObserver | null = null
  return (el: HTMLDivElement | null) => {
    observer?.disconnect()
    observer = null
    if (!el) return
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true)
      return
    }
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true)
            observer?.disconnect()
          }
        })
      },
      { rootMargin: '300px 0px' }
    )
    observer.observe(el)
  }
}

function MainComponent(): any {
  const { cookies, authHookWithEvent } = useAuth()
  const navigate = useNavigate()
  const isWebView = useIsWebView()
  const hiddenElement = isWebView ? 'hidden' : 'visible'
  const { isNative } = useBdApp()

  // verify if user has permission to acess
  useGuard(['DP2'])

  const [searchParams] = useSearchParams()
  const { setStateDate, stateDate } = useContext(DateContext)
  const { setStateLoader, stateLoader } = useContext(LoaderContext)
  const { id } = useParams<{ id: string }>()

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const newDate = new Date()
  const today = format(newDate, 'yyyy-MM-dd')

  // ALTERACAO AQUI
  const sdDateValidation = true
  const edDateValidation = true

  // GET DATE INTERVAL FROM SEARCH PARAMS
  const stDate = sdDateValidation ? today : searchParams.get('sd')
  const edDate = edDateValidation ? '2020-01-01' : searchParams.get('ed')

  const isDateDefault = sdDateValidation && edDateValidation

  const startDate = stateDate.startDate
  const endDate = stateDate.endDate

  // AUTH SECTION
  if (!LOCAL_EXECUTION) {
    authHookWithEvent(id!, navigate)
  }

  // SHOW DATA STATES
  const [sectors, setSectors] = useState<any>(mockSectors)
  const [dashboardData, setDashboardData] =
    useState<DashboardDataProps>(mockDashboardData)
  const [salesByDay, setSalesByDay] = useState<any>(mockSalesByDay)
  const [salesByHour, setSalesByHour] = useState<any>(mockSalesByHour)
  const [visitors, setVisitors] = useState<any>(mockVisitors)
  const [interestMeter, setInterestMeter] = useState<any>(mockInterestMeter)
  const [visitorsInformation, setVisitorsInformation] = useState<any>(
    mockVisitorsInformation
  )
  const [salesLocator, setSalesLocator] = useState<any>(mockSalesLocator)
  const [event, setEvent] = useState<any>(mockEvent)
  const [salesByProduct, setSalesByProduct] = useState<any>(mockSalesByProduct)
  const [heatMapCoords, setHeatMapCoords] = useState<any>(mockHeatMapCoords)
  const [paymentMethods, setPaymentMethods] = useState<any>(mockPaymentMethods)
  const [buyerRecurrence, setBuyerRecurrence] = useState<any>(mockBuyerRecurrence)
  const [salesCurve, setSalesCurve] = useState<any>(mockSalesCurve)
  const [campaignAttribution, setCampaignAttribution] = useState<any>(mockCampaignAttribution)
  const [showCurveConfig, setShowCurveConfig] = useState<boolean>(false)
  const [excludeCurveCourtesy, setExcludeCurveCourtesy] = useState<boolean>(false)
  const [excludeCourtesy, setExcludeCourtesy] = useState<boolean>(false)
  const [excludePayNonSales, setExcludePayNonSales] = useState<boolean>(false)

  // OVERFLOW CONTROL
  const [overflow, setOverflow] = useState<boolean>(false)

  // LAZY GA4 SECTIONS
  const [conversionInView, setConversionInView] = useState<boolean>(false)
  const [originInView, setOriginInView] = useState<boolean>(false)
  const conversionInViewRef = useMemo(
    () => makeInViewOnceRef(setConversionInView),
    []
  )
  const originInViewRef = useMemo(() => makeInViewOnceRef(setOriginInView), [])

  // DATE DAYS SELECTOR
  const [selectedItem, setSelectedItem] = useState<number | null>(null)

  let dataFormatada: string = ''

  const PA_PREFIX = 'producer/analytics/'

  const requestArray: RequestArrayProps[] = useMemo(
    () => [
      {
        url: `${PA_PREFIX}sectors?eventId=${id}`,
        state: setSectors,
        mock: mockSectors,
      },
      {
        url: `${PA_PREFIX}income?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setDashboardData,
        mock: mockDashboardData,
      },
      {
        url: `${PA_PREFIX}salesByDay?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setSalesByDay,
        mock: mockSalesByDay,
      },
      {
        url: `${PA_PREFIX}salesByHour?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setSalesByHour,
        mock: mockSalesByHour,
      },
      {
        url: `${PA_PREFIX}visitorsInformation?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setVisitorsInformation,
        mock: mockVisitorsInformation,
      },
      {
        url: `${PA_PREFIX}salesLocator?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setSalesLocator,
        mock: mockSalesLocator,
      },
      {
        url: `${PA_PREFIX}eventInfo?eventId=${id}`,
        state: setEvent,
        mock: mockEvent,
      },
      {
        url: `${PA_PREFIX}sectors/sales?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setSalesByProduct,
        mock: mockSalesByProduct,
      },
      {
        url: `${PA_PREFIX}salesHeatMapCoords?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setHeatMapCoords,
        mock: mockHeatMapCoords,
      },
      {
        url: `${PA_PREFIX}paymentMethods?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setPaymentMethods,
        mock: mockPaymentMethods,
      },
      {
        url: `${PA_PREFIX}buyerRecurrence?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setBuyerRecurrence,
        mock: mockBuyerRecurrence,
      },
      {
        url: `${PA_PREFIX}salesCurve?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setSalesCurve,
        mock: mockSalesCurve,
      },
    ],
    [id, endDate, startDate]
  )

  const conversionRequestArray: RequestArrayProps[] = useMemo(
    () => [
      {
        url: `${PA_PREFIX}visitorsByDay?eventId=${id}&startDate=${endDate}&endDate=${startDate}${stateDate.isDateDefault ? '&isFullDays=true' : ''
          }`,
        state: setVisitors,
        mock: mockVisitors,
      },
      {
        url: `${PA_PREFIX}interestMeter?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setInterestMeter,
        mock: mockInterestMeter,
      },
    ],
    [id, endDate, startDate, stateDate]
  )

  const originRequestArray: RequestArrayProps[] = useMemo(
    () => [
      {
        url: `${PA_PREFIX}campaignAttribution?eventId=${id}&startDate=${endDate}&endDate=${startDate}`,
        state: setCampaignAttribution,
        mock: mockCampaignAttribution,
      },
    ],
    [id, endDate, startDate]
  )

  useEffect(() => {
    setStateDate({
      startDate: stDate as string,
      endDate: edDate as string,
      isDateDefault,
    })
  }, [setStateDate, stDate, edDate, isDateDefault])

  const runRequest = async (
    request: RequestArrayProps,
    i: number,
    requestControl: any[]
  ) => {
    await APIDecoratorWithBaseURI()
      .get<any>(request.url)
      .then((r: any) => {
        // VERIFY IF RESPONSE IS AN ARRAY OR OBJECT
        if (Array.isArray(request.mock)) {
          if (r.data.body[0] !== undefined) {
            request.state(r.data.body)
          } else {
            request.mock[0].isLoading = false
            request.mock[0].isError = false
            request.mock[0].isMessage = true
            request.state(request.mock as any)
          }
        } else {
          if (r.data.body !== undefined) {
            request.state(r.data.body)
          } else {
            request.mock.isLoading = false
            request.mock.isError = false
            request.mock.isMessage = true
            request.state(request.mock as any)
          }
        }
        // MAIN RENDER CONTROL
        requestControl.push({
          index: i,
          success: true,
          data: r.data.body,
          url: request.url.replace('producer/analytics/', ''),
        })
      })
      .catch((error: any) => {
        // VERIFY IF DATA MODEL IS AN ARRAY OR OBJECT
        if (Array.isArray(request.mock)) {
          request.mock[0].isLoading = false
          request.mock[0].isError = true
          request.mock[0].isMessage = false
          request.state(request.mock as any)
        } else {
          request.mock.isLoading = false
          request.mock.isError = true
          request.mock.isMessage = false
          request.state(request.mock as any)
        }
        // MAIN RENDER CONTROL
        requestControl.push({
          index: i,
          success: false,
          data: error.toString(),
          url: request.url.replace('producer/analytics/', ''),
        })
      })
  }

  useEffect(() => {
    const requestControl: any[] = []
    const dateHasUpdated =
      stateDate.startDate !== '' && stateDate.endDate !== ''

    // AUTHTOKEN MUST BE TRUE EM DEV MODE
    const hasAuthToken = LOCAL_EXECUTION
      ? true
      : cookies.userJWT !== undefined && cookies.userJWT !== ''

    // AUTHTOKEN MUST BE TRUE EM DEV MODE
    if (dateHasUpdated && hasAuthToken) {
      const toastLoading = toast.success(
        <CenterElement>
          <LoadingSpinner />
          Carregando...
        </CenterElement>,
        {
          closeButton: false,
          autoClose: false,
          hideProgressBar: true,
          icon: false,
          style: {
            height: '60px',
          },
        }
      )
      Promise.allSettled(
        requestArray.map(async (request, i) =>
          runRequest(request, i, requestControl)
        )
      )
        .then((r) => {
          // VERIFICAR SE AO MENOS UMA REQUEST PASSOU
          const control = hasSuccessItem(requestControl)
          setStateLoader({
            loading: control,
          })
          animateScroll.scrollTo(0)
        })
        .finally(() => {
          toast.dismiss(toastLoading)
        })
    }
  }, [
    id,
    stateDate,
    endDate,
    requestArray,
    startDate,
    setStateLoader,
    cookies.userJWT,
  ])

  useEffect(() => {
    const dateHasUpdated =
      stateDate.startDate !== '' && stateDate.endDate !== ''
    const hasAuthToken = LOCAL_EXECUTION
      ? true
      : cookies.userJWT !== undefined && cookies.userJWT !== ''
    if (!conversionInView || !dateHasUpdated || !hasAuthToken) return
    Promise.allSettled(
      conversionRequestArray.map(async (request, i) =>
        runRequest(request, i, [])
      )
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversionInView, conversionRequestArray, stateDate, cookies.userJWT])

  useEffect(() => {
    const dateHasUpdated =
      stateDate.startDate !== '' && stateDate.endDate !== ''
    const hasAuthToken = LOCAL_EXECUTION
      ? true
      : cookies.userJWT !== undefined && cookies.userJWT !== ''
    if (!originInView || !dateHasUpdated || !hasAuthToken) return
    Promise.allSettled(
      originRequestArray.map(async (request, i) => runRequest(request, i, []))
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originInView, originRequestArray, stateDate, cookies.userJWT])

  useEffect(() => { }, [
    salesByDay,
    sectors,
    interestMeter,
    event,
    visitors,
    visitorsInformation,
    salesLocator,
    salesByProduct,
  ])

  // THE LAST ONE DATA MODELING INSIDE OF MAIN COMPONENT
  if (event) {
    const dataObj = parseISO(event.data)
    const formatoFinal = "d 'de' MMMM 'de' yyyy"
    dataFormatada = format(dataObj, formatoFinal, { locale: ptBR })
  }

  const handleClick = (day: any) => {
    setStateLoader({
      loading: true,
    })
    if (day !== null) {
      const startAndEndDate = dateFormat(day)
      setStateDate({
        startDate: startAndEndDate.newFormatStartDate,
        endDate: startAndEndDate.newFormatEndDate,
        isDateDefault: false,
      })
    } else {
      setStateDate({
        startDate: stDate as string,
        endDate: edDate as string,
        isDateDefault: false,
      })
    }
    setSelectedItem(day)
  }

  // THERE VARIBLES CONTROL IF COMPONENT RENDER IT SELF OR A MESSAGE OF NO DATA OR ERROR
  // ARRAY CONTROL
  const sectorsRenderControl =
    sectors[0].isLoading === undefined &&
    sectors[0].isMessage === undefined &&
    sectors[0].isError === undefined
  const salesByDayRenderControl =
    salesByDay[0].isLoading === undefined &&
    salesByDay[0].isMessage === undefined &&
    salesByDay[0].isError === undefined
  const salesByProductRenderControl =
    salesByProduct[0].isLoading === undefined &&
    salesByProduct[0].isMessage === undefined &&
    salesByProduct[0].isError === undefined
  const salesLocatorRenderControl =
    salesLocator[0].isLoading === undefined &&
    salesLocator[0].isMessage === undefined &&
    salesLocator[0].isError === undefined
  const visitorsRenderControl =
    visitors[0].isLoading === undefined &&
    visitors[0].isMessage === undefined &&
    visitors[0].isError === undefined
  const heatMapCoordsRenderControl =
    heatMapCoords[0].isLoading === undefined &&
    heatMapCoords[0].isMessage === undefined &&
    heatMapCoords[0].isError === undefined
  const paymentMethodsRenderControl =
    paymentMethods[0].isLoading === undefined &&
    paymentMethods[0].isMessage === undefined &&
    paymentMethods[0].isError === undefined

  // OBJECT CONTROL
  const interestMeterRenderControl =
    interestMeter.isLoading === undefined &&
    interestMeter.isMessage === undefined &&
    interestMeter.isError === undefined
  const visitorsInformationRenderControl =
    visitorsInformation.isLoading === undefined &&
    visitorsInformation.isMessage === undefined &&
    visitorsInformation.isError === undefined
  const buyerRecurrenceRenderControl =
    buyerRecurrence.isLoading === undefined &&
    buyerRecurrence.isMessage === undefined &&
    buyerRecurrence.isError === undefined
  const salesCurveRenderControl =
    salesCurve.isLoading === undefined &&
    salesCurve.isMessage === undefined &&
    salesCurve.isError === undefined
  const campaignAttributionRenderControl =
    campaignAttribution.isLoading === undefined &&
    campaignAttribution.isMessage === undefined &&
    campaignAttribution.isError === undefined

  // ---- NOVOS INDICADORES: dados derivados ----
  // % por estado (rosca em tons de cinza): deriva do MESMO salesLocator do mapa
  const GRAYSCALE = ['#101828', '#475467', '#667085', '#98A2B3', '#D0D5DD']
  const stateDonutData = (() => {
    const list = Array.isArray(salesLocator)
      ? salesLocator.filter(
          (s: any) => s && typeof s.quantidadeIngressos === 'number'
        )
      : []
    const sorted = [...list].sort(
      (a: any, b: any) => b.quantidadeIngressos - a.quantidadeIngressos
    )
    const items = sorted.slice(0, 4).map((s: any, i: number) => ({
      label: s.uf || s.estado || '—',
      value: s.quantidadeIngressos,
      quantity: s.quantidadeIngressos,
      color: GRAYSCALE[i],
    }))
    const restSum = sorted
      .slice(4)
      .reduce((sum: number, s: any) => sum + s.quantidadeIngressos, 0)
    if (restSum > 0) {
      items.push({ label: 'Outros', value: restSum, quantity: restSum, color: GRAYSCALE[4] })
    }
    return items
  })()

  // faixa etária cruzada por sexo (M x F por faixa)
  const ageGenderData = (visitorsInformation?.[0]?.IdadesSexo ?? []).map((i: any) => ({
    faixa: i.faixa,
    masculino: Number(i.masculino) || 0,
    feminino: Number(i.feminino) || 0,
    outros: Number(i.outros) || 0,
  }))

  // formas de pagamento (barras horizontais). O toggle remove Cortesia/Outros
  // (cortesia + Aprovação Automática) e recalcula o % só sobre as vendas de fato.
  const PAY_NON_SALES = ['CORTESIA', 'OUTRO']
  const paymentBase = (
    Array.isArray(paymentMethods)
      ? paymentMethods.filter((p: any) => p && p.label)
      : []
  ).filter((p: any) => !excludePayNonSales || !PAY_NON_SALES.includes(p.categoria))
  const paymentTotal = paymentBase.reduce(
    (sum: number, p: any) => sum + (Number(p.quantidade) || 0),
    0
  )
  const paymentData = paymentBase.map((p: any) => ({
    label: p.label,
    quantidade: p.quantidade,
    percentual:
      paymentTotal > 0 ? Number(((Number(p.quantidade) / paymentTotal) * 100).toFixed(2)) : 0,
  }))

  // recorrência: toggle escolhe o cenário com/sem cortesia (sem refetch)
  const recBucket = excludeCourtesy
    ? buyerRecurrence?.semCortesia
    : buyerRecurrence?.comCortesia

  // recarrega só a curva após salvar a configuração de períodos
  const refetchSalesCurve = () => {
    APIDecoratorWithBaseURI()
      .get<any>(`${PA_PREFIX}salesCurve?eventId=${id}&startDate=${endDate}&endDate=${startDate}`)
      .then((r: any) => {
        if (r?.data?.body) setSalesCurve(r.data.body)
      })
      .catch(() => undefined)
  }
  const eventRenderControl =
    event.isLoading === undefined &&
    event.isMessage === undefined &&
    event.isError === undefined
  const dashboardDataRenderControl =
    dashboardData.isLoading === undefined &&
    dashboardData.isMessage === undefined &&
    dashboardData.isError === undefined

  return (
    <FContainer>
      {overflow ? <DisableScroll /> : null}
      <Container isNative={isNative}>
        {stateLoader.loading ? (
          <Loader />
        ) : (
          <MainContainer>
            <ConditionalRenderComponent
              isLoading={event.isLoading === true}
              isMessage={event.isMessage === true}
              isError={event.isError === true}
              hasImage={true}
              maxHeight={100}
              isRender={eventRenderControl}
            >
              <Breadcrumb
                paths={[
                  { name: 'Início', path: '/start' },
                  { name: 'Evento', path: `/events/${id}` },
                  ...crumbs,
                ]}
              />
              <HeaderContainer>
                <TitleContainer>
                  <HeaderTitleText>{event.nome}</HeaderTitleText>
                  <DetailsContainer>
                    <DetailsTitleContainer>
                      <Img src={calendar} alt="calendar-icon" />
                      <HeaderDetailText>{dataFormatada}</HeaderDetailText>
                    </DetailsTitleContainer>
                    <DetailsTitleContainer>
                      <Img src={local} alt="place-icon" />
                      <HeaderDetailText>{event.endereco}</HeaderDetailText>
                    </DetailsTitleContainer>
                  </DetailsContainer>
                </TitleContainer>
              </HeaderContainer>
            </ConditionalRenderComponent>
            <DateManager>
              <SelectDateContainer>
                <SelectDateText
                  onClick={() => handleClick(null)}
                  className={selectedItem === null ? 'active' : ''}
                >
                  Total
                </SelectDateText>
                <SelectDateText
                  onClick={() => handleClick(0)}
                  className={selectedItem === 0 ? 'active' : ''}
                >
                  Hoje
                </SelectDateText>
                <SelectDateText
                  onClick={() => handleClick(1)}
                  className={selectedItem === 1 ? 'active' : ''}
                >
                  Ontem
                </SelectDateText>
                <SelectDateText
                  onClick={() => handleClick(6)}
                  className={selectedItem === 6 ? 'active' : ''}
                >
                  Últimos 7 dias
                </SelectDateText>
                <SelectDateText
                  onClick={() => handleClick(14)}
                  className={selectedItem === 14 ? 'active' : ''}
                >
                  Últimos 15 dias
                </SelectDateText>
                <SelectDateText
                  onClick={() => handleClick(29)}
                  className={selectedItem === 29 ? 'active' : ''}
                >
                  Últimos 30 dias
                </SelectDateText>
              </SelectDateContainer>
              <SelectDateContainerMobile>
                <SelectDateTextMobile
                  onClick={() => handleClick(null)}
                  className={selectedItem === null ? 'active' : ''}
                >
                  Total
                </SelectDateTextMobile>
                <SelectDateTextMobile
                  onClick={() => handleClick(0)}
                  className={selectedItem === 0 ? 'active' : ''}
                >
                  Hoje
                </SelectDateTextMobile>
                <SelectDateTextMobile
                  onClick={() => handleClick(1)}
                  className={selectedItem === 1 ? 'active' : ''}
                >
                  Ontem
                </SelectDateTextMobile>
                <SelectDateText
                  onClick={() => handleClick(6)}
                  className={selectedItem === 6 ? 'active' : ''}
                >
                  Últimos 7 dias
                </SelectDateText>
              </SelectDateContainerMobile>
              <div style={{ flex: 1 }} />
              <CalendarContiner>
                <CalendarDashboard />
              </CalendarContiner>
            </DateManager>

            <TotalCardContainer>
              <ConditionalRenderComponent
                isLoading={dashboardData.isLoading === true}
                isMessage={dashboardData.isMessage === true}
                isError={dashboardData.isError === true}
                isRender={dashboardDataRenderControl}
              >
                <>
                  <DashboardCard
                    variateCardDescriptionText="Total de receita"
                    variateValue={String(
                      dashboardData?.receitaTotal.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                    )}
                    isMonetaryValue={false}
                  >
                    <Icon
                      fill="#E60D1E"
                      classes="question-circle-help-center"
                      iconName="dashboardMoney"
                      width={27}
                      height={23}
                    />
                  </DashboardCard>
                  <DashboardCard
                    variateCardDescriptionText="Ticket Médio"
                    variateValue={`${dashboardData?.ticketMedio.toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}`}
                    isMonetaryValue={false}
                  >
                    <Icon
                      fill="#000"
                      classes="question-circle-help-center"
                      iconName="dashboardTicket"
                      width={27}
                      height={23}
                    />
                  </DashboardCard>
                  <DashboardCard
                    variateCardDescriptionText="Ingressos Vendidos"
                    variateValue={Number(
                      dashboardData?.quantidadeIngressosVendidos
                    ).toLocaleString('pt-BR')}
                    isMonetaryValue={false}
                  >
                    <Img src={star} />
                  </DashboardCard>
                  <DashboardCard
                    variateCardDescriptionText="Cortesias Distribuidas"
                    variateValue={Number(
                      dashboardData?.quantidadeCortesias
                    ).toLocaleString('pt-BR')}
                    isMonetaryValue={false}
                  >
                    <Icon
                      fill="#E60D1E"
                      classes="question-circle-help-center"
                      iconName="dashboardCourtesy"
                      width={27}
                      height={23}
                    />
                  </DashboardCard>

                  <DashboardCard
                    variateCardDescriptionText="Ingressos emitidos"
                    variateValue={Number(
                      dashboardData?.quantidadeIngressosTotal
                    ).toLocaleString('pt-BR')}
                    isMonetaryValue={false}
                  >
                    <Icon
                      fill="#E60D1E"
                      classes="question-circle-help-center"
                      iconName="dashboardTicketIcon"
                      width={27}
                      height={23}
                    />
                  </DashboardCard>
                </>
              </ConditionalRenderComponent>
            </TotalCardContainer>

            {/* SALES_BY_HOUR_SECTOR */}
            <SectionContainer>
              <SectionHeader
                title={'Vendas por Hora'}
                subTitle={
                  'Veja as métricas de vendas por hora do seu evento. Tenha insights para melhoria de perfomance e aumente suas vendas. '
                }
              />
              <SalesCardContainer>
                <ConditionalRenderComponent
                  isLoading={
                    salesByDay[0].isLoading === true ||
                    sectors[0].isLoading === true
                  }
                  isMessage={
                    salesByDay[0].isMessage === true ||
                    sectors[0].isMessage === true
                  }
                  isError={
                    salesByDay[0].isError === true ||
                    sectors[0].isError === true
                  }
                  isRender={salesByDayRenderControl && sectorsRenderControl}
                  maxHeight={100}
                  minHeight={100}
                >
                  <DashboardPageSalesByHourCard title="Vendas por Hora" sector={[]}>
                    <PageSalesByHourContainer data={salesByHour} />
                  </DashboardPageSalesByHourCard>
                </ConditionalRenderComponent>
              </SalesCardContainer>
            </SectionContainer>


            {/* SALES_SECTOR */}
            <SectionContainer>
              <SectionHeader
                title={'Vendas'}
                subTitle={
                  'Acompanhe suas vendas em diferentes perspectivas. Tenha os seus indicadores na palma da mão e torne a gestão de eventos efetiva.'
                }
              />
              <SalesCardContainer>
                <ConditionalRenderComponent
                  isLoading={
                    salesByDay[0].isLoading === true ||
                    sectors[0].isLoading === true
                  }
                  isMessage={
                    salesByDay[0].isMessage === true ||
                    sectors[0].isMessage === true
                  }
                  isError={
                    salesByDay[0].isError === true ||
                    sectors[0].isError === true
                  }
                  isRender={salesByDayRenderControl && sectorsRenderControl}
                >
                  <DashboardSalesChart
                    label="Ingressos"
                    sales={salesByDay}
                    sectors={sectors}
                  />
                </ConditionalRenderComponent>
              </SalesCardContainer>
            </SectionContainer>

            {/* CONVERSION_SECTOR (GA4 — carrega ao entrar no viewport) */}
            <SectionContainer ref={conversionInViewRef}>
              <SectionHeader
                title={'Conversão'}
                subTitle={
                  'Veja as métricas de conversão do seu evento. Tenha insights para melhoria de perfomance e aumente suas vendas. '
                }
              />
              <PageVisitsCardContainer>
                <ConditionalRenderComponent
                  isLoading={visitors[0].isLoading === true}
                  isMessage={visitors[0].isMessage === true}
                  isError={visitors[0].isError === true}
                  isRender={visitorsRenderControl}
                >
                  <>
                    <DashboardPageVistitsCard title="Visitas a página">
                      <PageVisitsContainer visitors={visitors} />
                    </DashboardPageVistitsCard>
                  </>
                </ConditionalRenderComponent>
                {/* -------------------------------- */}
                <ConditionalRenderComponent
                  isLoading={interestMeter.isLoading === true}
                  isMessage={interestMeter.isMessage === true}
                  isError={interestMeter.isError === true}
                  isRender={interestMeterRenderControl}
                >
                  <InterestMeterContainer interestMeter={interestMeter} />
                </ConditionalRenderComponent>
              </PageVisitsCardContainer>
            </SectionContainer>

            {/* VENDAS POR SETOR + MAPA */}
            <SectionContainer>
              <SalesByProductContainer>
                <ConditionalRenderComponent
                  isLoading={salesByProduct[0].isLoading === true}
                  isMessage={salesByProduct[0].isMessage === true}
                  isError={salesByProduct[0].isError === true}
                  isRender={salesByProductRenderControl}
                >
                  <DashboardSalesByProductCard
                    sector={salesByProduct}
                    title={'Vendas por setor'}
                  />
                </ConditionalRenderComponent>
              </SalesByProductContainer>
              {/* LINHA 1: Mapa de Vendas + Estados (rosca em tons de cinza) num card */}
              <ConditionalRenderComponent
                isLoading={salesLocator[0].isLoading === true}
                isMessage={salesLocator[0].isMessage === true}
                isError={salesLocator[0].isError === true}
                isRender={salesLocatorRenderControl}
              >
                <GeoSalesCard data={salesLocator} donutItems={stateDonutData} />
              </ConditionalRenderComponent>
            </SectionContainer>

            {/* METAS_SECTOR */}
            <SectionContainer className={hiddenElement}>
              <SectionHeader
                title={'Metas'}
                subTitle={
                  'Defina as metas dos seus eventos. Acompanhe seu progresso e monitore de perto o desempenho das vendas.'
                }
              />
              {/* GOALS NOW IS BOTH MOBILE AND DESKTOP */}
              <GoalsManagerCardContainer>
                <ManagerGoalsCard
                  setOverflow={setOverflow}
                  startDate={startDate}
                  endDate={endDate}
                />
              </GoalsManagerCardContainer>
            </SectionContainer>

            {/* LINHA 2: Compradores (gênero) + Faixa etária (M x F) */}
            <SectionContainer>
              <CardsRow>
                <ConditionalRenderComponent
                  isLoading={visitorsInformation.isLoading === true}
                  isMessage={visitorsInformation.isMessage === true}
                  isError={visitorsInformation.isError === true}
                  isRender={visitorsInformationRenderControl}
                >
                  <DashboardVisitorsCard title="Compradores">
                    <DashboardVisitorsChart
                      data={visitorsInformation.map((data: any) => ({
                        Masculino: data.Masculino,
                        Feminino: data.Feminino,
                        'Não inserido': data.Undefined,
                      }))}
                    />
                  </DashboardVisitorsCard>
                </ConditionalRenderComponent>

                <ConditionalRenderComponent
                  isLoading={visitorsInformation.isLoading === true}
                  isMessage={visitorsInformation.isMessage === true}
                  isError={visitorsInformation.isError === true}
                  isRender={visitorsInformationRenderControl}
                >
                  <IndicatorCard title="Faixa etária">
                    <AgeGenderChart items={ageGenderData} />
                  </IndicatorCard>
                </ConditionalRenderComponent>
              </CardsRow>
            </SectionContainer>

            {/* LINHA 3: Formas de pagamento + Recorrência */}
            <SectionContainer>
              <CardsRow>
                <ConditionalRenderComponent
                  isLoading={paymentMethods[0].isLoading === true}
                  isMessage={paymentMethods[0].isMessage === true}
                  isError={paymentMethods[0].isError === true}
                  isRender={paymentMethodsRenderControl}
                >
                  <IndicatorCard
                    title="Formas de pagamento"
                    action={
                      <ToggleLabel>
                        <input
                          type="checkbox"
                          checked={excludePayNonSales}
                          onChange={(e) => setExcludePayNonSales(e.target.checked)}
                        />
                        Excluir cortesias / AA
                      </ToggleLabel>
                    }
                  >
                    <PaymentBars items={paymentData} />
                  </IndicatorCard>
                </ConditionalRenderComponent>

                <ConditionalRenderComponent
                  isLoading={buyerRecurrence.isLoading === true}
                  isMessage={buyerRecurrence.isMessage === true}
                  isError={buyerRecurrence.isError === true}
                  isRender={buyerRecurrenceRenderControl}
                >
                  <IndicatorCard
                    title="Recorrência"
                    action={
                      <ToggleLabel>
                        <input
                          type="checkbox"
                          checked={excludeCourtesy}
                          onChange={(e) => setExcludeCourtesy(e.target.checked)}
                        />
                        Excluir cortesias
                      </ToggleLabel>
                    }
                  >
                    <RecurrenceGauges bucket={recBucket} />
                  </IndicatorCard>
                </ConditionalRenderComponent>
              </CardsRow>
            </SectionContainer>

            {/* ORIGEM DAS VENDAS (Cockpit de Campanhas — GA4, carrega ao entrar no viewport) */}
            <SectionContainer ref={originInViewRef}>
              <ConditionalRenderComponent
                isLoading={campaignAttribution.isLoading === true}
                isMessage={campaignAttribution.isMessage === true}
                isError={campaignAttribution.isError === true}
                isRender={campaignAttributionRenderControl}
              >
                <IndicatorCard title="Origem das vendas">
                  <SalesOrigin data={campaignAttribution} />
                </IndicatorCard>
              </ConditionalRenderComponent>
            </SectionContainer>

            {/* CURVA DE VENDAS */}
            <SectionContainer>
              <ConditionalRenderComponent
                isLoading={salesCurve.isLoading === true}
                isMessage={salesCurve.isMessage === true}
                isError={salesCurve.isError === true}
                isRender={salesCurveRenderControl}
              >
                <IndicatorCard
                  title="Curva de Vendas"
                  action={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <ToggleLabel>
                        <input
                          type="checkbox"
                          checked={excludeCurveCourtesy}
                          onChange={(e) => setExcludeCurveCourtesy(e.target.checked)}
                        />
                        Excluir cortesias
                      </ToggleLabel>
                      <GearButton type="button" onClick={() => setShowCurveConfig(true)}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
                        Configurar períodos
                      </GearButton>
                    </div>
                  }
                >
                  <SalesCurveCard data={salesCurve} excludeCortesias={excludeCurveCourtesy} />
                </IndicatorCard>
              </ConditionalRenderComponent>
            </SectionContainer>

            {showCurveConfig && (
              <SalesCurveConfigModal
                eventId={id as string}
                onClose={() => setShowCurveConfig(false)}
                onSaved={refetchSalesCurve}
              />
            )}

            {/* HEATMAP_SECTOR */}
            <SectionContainer className={hiddenElement}>
              <SectionHeader
                title={'Localizador de Vendas'}
                subTitle={
                  'Monitore suas vendas por região de compras. Saiba exatamente onde está o seu público.'
                }
              />
              <HeatMapContainer>
                <ConditionalRenderComponent
                  isLoading={heatMapCoords[0].isLoading === true}
                  isMessage={heatMapCoords[0].isMessage === true}
                  isError={heatMapCoords[0].isError === true}
                  isRender={heatMapCoordsRenderControl}
                >
                  <SalesMap
                    heatMapPositions={heatMapCoords}
                    initialZoom={4}
                    width="100%"
                    height="454px"
                  />
                </ConditionalRenderComponent>
              </HeatMapContainer>
            </SectionContainer>
          </MainContainer>
        )}
      </Container>
    </FContainer>
  )
}

export default MainComponent
